export default [
  {
    path: '/i18n',
    name: 'i18n-editor',
    component: () => import(/* webpackChunkName: "i18n" */ './Index.vue')
  }
]
